export default () => ({
  SYS_FILEDOWNLOAD(fileID, { isAutoDown, preview } = { isAutoDown: true, preview: false }) {
    const urls = [process.env.VUE_APP_FILES_DOMAIN, 'download', fileID]
    if(preview) {
      urls.push('?preview=1')
    }
    let url = urls
      .filter(Boolean)
      .map((t) => t.replace(/(^\/)|(\/$)/g, ''))
      .join('/')
    if (!url.startsWith('http') && !url.startsWith('blob:')) {
      url = '/' + url
    }
    if (isAutoDown) {
      window.open(url)
    }
    return
  }
})
